import { resolveSettings } from './deployment';

const { BASE_URL, API_URL, SOCKET_URL, MEDIA_URL, ENVIRONMENT, DOMAIN, HOST } =
  resolveSettings(process.env.REACT_APP_GOAL, window.location.hostname);

export { BASE_URL, API_URL, SOCKET_URL, MEDIA_URL, ENVIRONMENT, DOMAIN, HOST };
